import * as yup from 'yup';
import {
  ReleaseVersion,
  UpdateReleaseVersionValidations,
  UpdateSoundCloudReleaseVersionPatchData,
} from 'types/releases';
import { fieldValidationMessages } from 'app/constants';
import { emptyStringToNull } from 'app/utils/utils';
import { DDL, Option } from 'types/general.types';
import { Audio } from 'types/audio';
import { SoundCloudVersionDetailsFormData } from './types';

export const getUpdateVersionValidationSchema = (
  metadataValidations: UpdateReleaseVersionValidations
) => {
  const { versionTitle } = metadataValidations;

  return yup.object().shape({
    versionTitle: yup
      .string()
      .required(fieldValidationMessages.REQUIRED)
      .max(
        versionTitle.maxLength,
        fieldValidationMessages.MAX_CHAR(versionTitle.maxLength)
      ),
    description: yup
      .string()
      .max(
        versionTitle.maxLength,
        fieldValidationMessages.MAX_CHAR(versionTitle.maxLength)
      ),
  });
};

export const getFirstDefaultGenre = (
  genres: string[] = [],
  genresDDL: DDL
): Option | null => {
  const firstGenre = genresDDL[genres[0]];
  return firstGenre
    ? ({ title: firstGenre.name, value: firstGenre.key } as Option)
    : null;
};

export const getPreferredAudioSelectionOption = (audio: Audio | null) => {
  return audio
    ? {
        title: audio.title,
        value: audio.guid,
        latest: audio.isLatestVersion,
        audioData: audio,
      }
    : null;
};

export const getDefaultValues = (
  version: ReleaseVersion,
  genresDDL: DDL
): SoundCloudVersionDetailsFormData => ({
  genre: getFirstDefaultGenre(version.song.snapshot.genres || [], genresDDL),
  excludeLyrics: version.lyrics?.isExcluded || false,
});
export const convertSCFormDataToVersionPatchData: (
  data: Partial<SoundCloudVersionDetailsFormData>
) => UpdateSoundCloudReleaseVersionPatchData = (data) => {
  const songData = {
    ...(data.genres ? { genres: data.genres } : {}),
  };
  const isSongDataNotEmpty = Object.values(songData).length > 0;
  return {
    ...(data.versionTitle ? { versionTitle: data.versionTitle } : {}),
    ...(data.description || data?.description === ''
      ? { description: emptyStringToNull(data.description) }
      : {}),
    ...(isSongDataNotEmpty
      ? {
          song: songData,
        }
      : {}),
  };
};
